import React, { useState, useEffect } from "react";
// FIX: Import auth from local file, but functions from SDK
import { auth } from "./firebase";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { motion } from "framer-motion";

export default function VerifyEmail({ onVerified }) {
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // Check if the current URL is a sign-in link
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn');
      
      // If email is missing (user opened link on different device), prompt for it
      if (!email) {
        email = window.prompt('Please provide your email for confirmation');
      }

      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          // Clear email from storage
          window.localStorage.removeItem('emailForSignIn');
          setStatus("success");
        })
        .catch((error) => {
          setStatus("error");
          setErrorMessage(error.message);
        });
    } else {
        // Fallback if accessed directly without a link
        setStatus("error");
        setErrorMessage("Invalid verification link.");
    }
  }, []);

  return (
    <div style={styles.container}>
      <motion.div 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        style={styles.card}
      >
        {status === "success" && (
            <>
                <div style={styles.iconContainer}>
                    <span style={{color:'white', fontSize:'24px'}}>✓</span>
                </div>
                <h1 style={styles.title}>Email Verification</h1>
                <p style={styles.text}>
                  Your email was verified. You can<br/>continue using the application.
                </p>
                <button onClick={onVerified} style={styles.continueBtn}>
                    Continue
                </button>
            </>
        )}

        {status === "verifying" && (
            <>
                <div style={{...styles.iconContainer, backgroundColor: '#eee'}}>
                    <span style={{fontSize: '24px'}}>⏳</span>
                </div>
                <h3>Verifying...</h3>
            </>
        )}

        {status === "error" && (
            <>
                 <div style={{...styles.iconContainer, backgroundColor: '#F07167'}}>
                    <span style={{fontSize: '24px', color: 'white'}}>✕</span>
                </div>
                <h1 style={styles.title}>Verification Failed</h1>
                <p style={styles.text}>{errorMessage}</p>
                <button onClick={onVerified} style={styles.continueBtn}>
                    Return Home
                </button>
            </>
        )}

      </motion.div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F8F9FA",
    fontFamily: "'Syne', sans-serif"
  },
  card: {
    backgroundColor: "white",
    padding: "50px 40px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    width: "400px",
    textAlign: "center",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid #000'
  },
  iconContainer: {
    width: "60px",
    height: "60px",
    backgroundColor: "#8BC34A",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px"
  },
  title: {
    fontSize: "24px",
    fontWeight: "400",
    color: "#222",
    marginBottom: "15px",
    margin: 0
  },
  text: {
    fontSize: "16px",
    color: "#555",
    lineHeight: "1.5",
    marginBottom: "30px"
  },
  continueBtn: {
      padding: '10px 30px',
      backgroundColor: '#222',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px'
  }
};